import PropTypes from 'prop-types'
import { Alert, Box, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import LinkButtonTooltip from '../../../ui/components/LinkButtonTooltip'
import TextWithDropdown from '../../../ui/components/TextWithDropdown'

import styles from './styles'
import { useGeneralRates } from '../../../services/billing'
import { useUserContext } from '../../../auth/UserProvider'
import { format } from 'date-fns'
import { generateCustomPDF } from './RatesReportPDF'

const propTypes = {
  loadingLastRate: PropTypes.bool,
  openLastRate: PropTypes.func,
  openRate: PropTypes.func,
}

const RatesView = ({ loadingLastRate, openLastRate, openRate }) => {
  const t = useTranslations()
  const { clientCode } = useUserContext()
  const user = useUserContext()

  const generalRates = useGeneralRates(
    clientCode,
    format(new Date(), `yyyy-MM-dd`),
  )

  const downloadAndOpenLastRate = async selectedRate => {
    const rates = await openRate(selectedRate, format(new Date(), `yyyy-MM-dd`))
    if (rates && rates.data) {
      let text = generalRates?.data.find(e => e?.value === selectedRate)?.label
      text = text.replace('Tarifa empresa 2024', 'Tarifa CTT Express')
      generateCustomPDF(rates.data, t, user, text)
    }
  }

  const handleOpenLastRateClick = date => e => {
    e.preventDefault()
    openLastRate(date)
  }

  return (
    <>
      <Alert severity="info" sx={styles.alert}>
        <Typography variant="h4" sx={styles.alertTitle}>
          {t('billing:subtitle')}
        </Typography>
        <Box sx={styles.row}>
        <LinkButtonTooltip
          text={t('billing:see-my-rate-2024')}
          onClick={handleOpenLastRateClick('2024-01-01')}
        />
        <Box sx={styles.linkButton2025}>
        <LinkButtonTooltip
          text={t('billing:see-my-rate-2025')}
          onClick={handleOpenLastRateClick('2025-01-01')}
        />
        </Box>
        </Box>
      </Alert>
      <Alert severity="info" sx={styles.alert}>
        <Typography variant="h4" sx={styles.alertTitle2}>
          {t('billing:see-rates')}
        </Typography>
        <TextWithDropdown
          options={
            generalRates?.data?.length
              ? generalRates?.data
              : [
                  {
                    label: t('billing:select-bill'),
                    value: null,
                    client_commited_deliveries: 0,
                    disabled: true,
                  },
                ]
          }
          defaultOption={null}
          onChange={e => {
            downloadAndOpenLastRate(e.target.value)
          }}
        />
      </Alert>
    </>
  )
}

RatesView.propTypes = propTypes

export default RatesView
